import { Reveal } from "@/components/Motion";

const chapters = [
  {
    no: "01",
    title: "Ervaring",
    body: "Jarenlange ervaring in residentiële bouw, van vrijstaande woningen tot kleinschalige projecten. We kennen het terrein en bouwen met kennis van zaken.",
  },
  {
    no: "02",
    title: "Filosofie",
    body: "We geloven in tijdloze architectuur die comfortabel woont en zijn waarde behoudt. Sober, warm en doordacht — zonder overbodige franjes.",
  },
  {
    no: "03",
    title: "Vakmanschap",
    body: "Elke woning wordt afgewerkt met aandacht voor detail en kwaliteitsvolle, duurzame materialen die mooi verouderen.",
  },
  {
    no: "04",
    title: "Persoonlijke aanpak",
    body: "Eén aanspreekpunt, korte lijnen en transparante communicatie. We bouwen samen met u, van eerste schets tot sleutel.",
  },
];

const About = () => {
  return (
    <section id="over-ons" className="relative bg-white py-24 md:py-32 lg:py-40 grain overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <Reveal>
              <div className="flex items-center gap-4 mb-6">
                <span className="h-px w-12 bg-forest" />
                <span className="font-body text-xs tracking-[0.25em] uppercase text-forest">
                  Over LX Bouw
                </span>
              </div>
              <h2 className="font-heading font-light tracking-tight text-4xl md:text-5xl leading-[1.1] text-ink text-balance">
                Een bouwbedrijf met de blik van een architectuurstudio.
              </h2>
              <div className="mt-10 relative overflow-hidden rounded-2xl md:rounded-[2rem] aspect-[3/4] shadow-[0_20px_55px_rgba(45,51,47,0.09)]">
                <img
                  src="https://images.pexels.com/photos/6963787/pexels-photo-6963787.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  alt="Minimalistisch interieur met warme, natuurlijke materialen"
                  className="absolute inset-0 h-full w-full object-cover"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-8">
            <div className="grid sm:grid-cols-2 gap-x-12 gap-y-14">
              {chapters.map((c, i) => (
                <Reveal key={c.no} delay={i * 0.08}>
                  <div className="border-t border-stone pt-6">
                    <span className="font-heading text-forest text-sm tracking-widest">
                      {c.no}
                    </span>
                    <h3 className="font-heading font-normal text-2xl text-ink mt-4 mb-3 tracking-tight">
                      {c.title}
                    </h3>
                    <p className="font-body text-slate2 leading-relaxed">{c.body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
